import * as React from 'react'
import { Spin } from 'antd'

const { lazy } = React
const { Suspense } = React

const Loading = (
  <Spin spinning>
    <div style={{ width: '100vw', height: '100vh' }} />
  </Spin>
)

export default routes => routes.map(({ loader, path, checkUrl }) => {
  const Component = lazy(loader)
  return {
    path,
    checkUrl,
    component: (props) => (
      <Suspense fallback={Loading}>
        <Component {...props} />
      </Suspense>
    ),
  }
})
